<template>
  <div>
    <!--过程证据弹窗-->
    <el-dialog
      :visible.sync="sdetailsDialog"
      width="600px"
      class="sdetails-dialog"
      title="全证据链"
      @open="openDialog"
      @close="closeDialog"
    >
      <div class="sdetails" v-if="applySignRecord && applySignRecord.length > 0">
        <template v-for="(item, index) in applySignRecord">
          <div class="sdetails-item" v-if="item.signType !== 11" :key="index">
            <h5 v-if="item.signType == 1">签署方</h5>
            <h5 v-if="item.signType == 14">发起方</h5>
            <h5 v-if="item.signType == 16">
              发起方（{{ item.identityCard }}）
              <span>发起撤销</span>
            </h5>
            <h5 v-if="item.signType === 18">确认签署</h5>
            <h5 v-if="item.signType === 20">催签</h5>
            <h5 v-if="item.signType === 23">注册认证信息</h5>
            <!--            <h5 v-if="item.signType===21">身份证二要素</h5>-->
            <!--            <h5 v-if="item.signType===22">企业工商三要素</h5>-->
            <template v-if="item.signType !== 24">
              <p v-show="item.identityCard">证件号：{{ item.identityCard }}</p>
              <p v-show="item.name">名称：{{ item.name }}</p>
            </template>
            <template v-if="item.signType == 1">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <p>终端IP：{{ item.ip }}</p>
              <p>地址：{{ item.url }}</p>
              <p v-if="item.userAgent && item.userAgent != ''">浏览器UA：{{ item.userAgent }}</p>
              <p v-if="item.addr">地理位置：{{ item.addr }}</p>
            </template>
            <template v-else-if="item.signType == 2">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <p>身份认证</p>
              <p>认证方式：{{ item.bank }}</p>
              <p>认证信息：{{ item.cardNo }}</p>
              <p>流水号:{{ item.orderNo }}</p>
              <p>验证成功.</p>
            </template>
            <template v-else-if="item.signType == 3">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <p>身份认证</p>
              <br />
              <p>认证方式：银行U盾</p>
              <p>流水号:{{ item.orderNo }}</p>
            </template>

            <template v-else-if="item.signType == 4">
              <p v-if="item.signRefcode">CA证书序列号：{{ item.signRefcode }}</p>
              <p v-if="item.signStartTime && item.signExpireTime">
                CA证书有效期：{{ item.signStartTime }} 至
                {{ item.signExpireTime }}
              </p>
              <p v-if="item.createTime">时间：{{ item.createTime | formatDateTime }}</p>
              <p v-if="item.signingTipsContent">已阅读并确认：{{ item.signingTipsContent }}</p>
              <b>{{ item.name }} 签署完成</b>
              <br />

              <p v-if="item.contractNames && item.contractNames.length > 0">文件名称：</p>
              <p v-for="(v, i) in item.contractNames" :key="i">{{ v }}</p>
              <p v-if="item.addr">地理位置：{{ item.addr }}</p>
              <div>系统已自动将签署证据提交至第三方机构（保全中心、公证处、司法鉴定中心等）</div>
            </template>
            <template v-else-if="item.signType == 23">
              <b>认证方式:{{ fluStatus(item.authType, item.userType) }}</b>
              <br />

              <p>认证时间：{{ item.authDate }}</p>
              <p>流水号：{{ item.orderNo }}</p>
              <p v-if="item.authType == 1 && item.context">匹配百分比：{{ item.context }}%</p>
              <p v-else>认证结果：通过</p>
            </template>
            <template v-else-if="item.signType == 5">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b>拒签</b>
              <p>
                拒签理由：
                {{ item.context }}
              </p>
              <p v-if="item.addr">地理位置：{{ item.addr }}</p>
            </template>
            <template v-else-if="item.signType == 6">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b>存证成功</b>
              <br />
              <p>上传{{ item.fileName }}成功，Hash值：{{ item.docHash }}</p>
            </template>
            <template v-else-if="item.signType == 7">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b>删除存证</b>
              <br />
              <p>删除{{ item.fileName }}成功，Hash值：{{ item.docHash }}</p>
            </template>
            <template v-else-if="item.signType == 8">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b class="color-primary">存证成功({{ item.storeType }})</b>
              <br />
              <div>备案号：{{ item.presId }}</div>
            </template>
            <template v-else-if="item.signType == 9">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b>备注</b>
              <br />
              <p>{{ item.context }}</p>
            </template>
            <template v-else-if="item.signType == 10">
              <b>人脸识别认证</b>
              <br />
              <p>
                认证时间：{{
                (!item.faceTime ? item.createTime : item.faceTime)
                | formatDateTime
                }}
              </p>
              <p>流水号:{{ item.orderNo }}</p>
              <p
                v-if="item.faceAuthName && item.faceAuthIdNo"
              >授权人:{{ item.faceAuthName }}({{ item.faceAuthIdNo }})</p>
              <p v-if="item.context">匹配百分比:{{ parseFloat(item.context).toFixed(2) + "%" }}</p>
              <p v-if="item.docHash">人脸识别视频存证成功,Hash值:{{ item.docHash }}</p>
            </template>
            <template v-else-if="item.signType == 12">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b>转签</b>
              <br />
              <div>{{ item.context }}</div>
            </template>
            <template v-else-if="item.signType == 13">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <div>
                本次签署为连续签署，上一份签署【{{
                item.context
                }}】已完成签署并记录签署日志（连续签署必须按照顺序依次连续完成签署，不可中途中断签署或跳过第一份文件进行签署，身份验证适用于每一份连续签署）。
              </div>
            </template>
            <template v-else-if="item.signType == 14">
              <p>终端IP：{{ item.ip }}</p>
              <p>地址：{{ item.url }}</p>
              <p v-if="item.userAgent">浏览器UA：{{ item.userAgent }}</p>
              <p v-if="item.addr">地理位置：{{ item.addr }}</p>
              <p v-if="item.createTime">时间：{{ item.createTime | formatDateTime }}</p>
              <b v-if="item.themeName">发起文件</b>
              <br />
              <p v-if="item.themeName">主题名称：{{ item.themeName }}</p>
              <p v-if="item.contractNames && item.contractNames.length > 0">文件名称：</p>
              <p v-for="(v, i) in item.contractNames" :key="i">{{ v }}</p>
              <!-- 1808-->
              <div v-if="item.readTimeSignInfoList && item.readTimeSignInfoList.length">
                <p
                  v-for="(childItem, childIndex) in item.readTimeSignInfoList"
                  :key="'xxx'+ childIndex"
                >发起方给签署方（{{childItem.name}}）设置了{{childItem.readTime}}s强制阅读</p>
              </div>
              <b v-if="isAttend">上传附属材料</b>
              <br />
              <template v-for="(file, i) in applySignRecord">
                <div :key="'xx' + i">
                  <template v-if="file.signType == 11">
                    <p>
                      {{ file.sourceName }}，上传{{
                      file.fileName
                      }}成功，Hash值：{{ file.docHash }}
                    </p>
                  </template>
                </div>
              </template>
              <b v-if="item.notify && item.notify.length > 0">签署通知</b>
              <template v-if="item.notify && item.notify.length > 0">
                <div v-for="elem of item.notify" :key="elem.idNo">
                  <p>证件号：{{ elem.idNo }}</p>
                  <p>名称：{{ elem.name }}</p>
                  <p>时间：{{ elem.createTime }}</p>
                  <p>接收号码：{{ elem.target }}</p>
                </div>
              </template>
              <template v-if="item.signingTipsList && item.signingTipsList.length">
                <div v-for="(sign,i) in item.signingTipsList" :key="i">
                  <p v-if="sign.signatoryFullName">指定签署方（{{sign.signatoryFullName }}）阅读并确认。</p>
                  <p v-if="sign.signingTipsTitle">签署提示标题：{{ sign.signingTipsTitle }}</p>
                  <p v-if="sign.signingTipsContent">已阅读并确认：{{ sign.signingTipsContent }}</p>
                </div>
              </template>
            </template>
            <!-- 15 -->
            <template v-else-if="item.signType == 15">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b>身份认证</b>
              <p>认证方式：短信验证码</p>
              <p>认证信息：{{ item.mobile }}</p>
              <p>验证成功.</p>
            </template>
            <!--16-->
            <template v-else-if="+item.signType === 16">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <p>终端IP：{{ item.ip }}</p>
              <p v-if="item.userAgent && item.userAgent != ''">浏览器UA：{{ item.userAgent }}</p>
              <p v-if="item.addr">地理位置：{{ item.addr }}</p>
            </template>
            <template v-else-if="item.signType == 17">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <b>保管函</b>
              <p>编号：{{ getId(item.safeKeepLetterId) }}</p>
            </template>
            <template v-else-if="item.signType == 18">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <p v-if="item.signingTipsContent">已阅读并确认：{{ item.signingTipsContent }}</p>
              <p>{{ item.name }}确认签署</p>
              <p>终端IP：{{ item.ip }}</p>
              <p v-if="item.addr">地理位置：{{ item.addr }}</p>
            </template>
            <template v-else-if="item.signType == 19">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <p>身份认证</p>
              <p>认证方式：运营商三要素</p>
              <p>认证信息：{{ item.mobile }}</p>
              <p>流水号:{{ item.orderNo }}</p>
              <p>验证成功.</p>
            </template>
            <!--催签-->
            <template v-else-if="item.signType == 20">
              <p
                v-if="item.signType != 10 && item.createTime"
              >时间：{{ item.createTime | formatDateTime }}</p>
              <p>通知短信：{{ item.mobile }}</p>
            </template>
            <!--   21 22         -->
            <template v-else-if="item.signType == 21 || item.signType == 22">
              <ul class="verification_ul">
                <li class="verification_li" v-if="item.signType == 21">身份证二要素</li>
                <li class="verification_li" v-if="item.signType == 22">企业工商三要素</li>
              </ul>
              <p>
                认证时间：{{
                (!item.faceTime ? item.createTime : item.faceTime)
                | formatDateTime
                }}
              </p>
              <p>流水号:{{ item.orderNo }}</p>
              <p>验证结果：校验成功</p>
            </template>
            <template v-else-if="item.signType === 24">
              <h5>签署短信信息</h5>
              <p>发送方名称：{{ item.name }}</p>
              <p>发送方证件号：{{ item.identityCard }}</p>
              <p>短信发送时间：{{ item.createTime }}</p>
              <p>接收方名称：{{ item.notify[0] ? item.notify[0].name : '' }}</p>
              <p>接收方证件号：{{ item.notify[0] ? item.notify[0].idNo : ''}}</p>
            </template>
            <template v-else-if="item.signType == 25">
              <b>AI鉴证</b>
              <br/>
              <p>认证时间：{{ item.aiAuthTime }}</p>
              <p>流水号:{{ item.orderNo }}</p>
              <p>人脸识别相似度：{{ item.similarity }}</p>
              <p>AI鉴证结果：通过</p>
            </template>
            <template v-else-if="item.signType == 26">
              <b class="high-light">视频单录</b>
              <!--            <br />-->
              <p>认证时间：{{item.asrTime | formatDateTime }}</p>
              <p>流水号:{{ item.orderNo }}</p>
              <p>语义是否一致：是</p>
              <p>相似度：{{item.similarity}}%</p>
            </template>
          </div>
        </template>
      </div>
      <div v-else class="sdetails">没有过程证据</div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postApplySignRecord,
  postApplySignRecordMulti,
  postCheckFilesStatus
} from "../../assets/js/http-serve/http-methods";

export default {
  name: "processEvidence",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    queryData: {
      // 查询参数，没有的话就从url里面取
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      sdetailsDialog: false,
      applySignRecord: [],
      isAttend: false,
      verificationList: [
        { name: "身份证二要素", value: 0 },
        { name: "企业工商三要素", value: 1 },
        { name: "银行卡三/四要素", value: 2 }
      ]
    };
  },
  watch: {
    show (newVal) {
      this.sdetailsDialog = newVal;
    }
  },
  created () {
    this.sdetailsDialog = this.show;
  },
  mounted () {
    let query = !this.$utils.isEmptyObj(this.queryData)
      ? this.queryData
      : this.$route.query;
    postCheckFilesStatus(query)
      .then(({ data }) => {
        if (data.multiFiles) {
          postApplySignRecordMulti(query)
            .then(({ data }) => {
              if (data) {
                this.applySignRecord = data;
                let arr = this.applySignRecord.filter(v => v.signType === 11);
                this.isAttend = arr.length > 0 ? true : false;
              }
            })
            .catch(err => {
              console.error("合同过程证据：" + JSON.stringify(err));
            });
        } else {
          postApplySignRecord(query)
            .then(({ data }) => {
              if (data) {
                this.applySignRecord = data;
                let arr = this.applySignRecord.filter(v => v.signType === 11);
                this.isAttend = arr.length > 0 ? true : false;
              }
            })
            .catch(err => {
              console.error("合同过程证据：" + JSON.stringify(err));
            });
        }
      })
      .catch(err => {
        console.error("判断合同类型信息：" + JSON.stringify(err));
      });
  },
  methods: {
    openDialog () {
      this.$emit("update:show", true);
    },
    closeDialog () {
      this.$emit("update:show", false);
    },
    getId (id) {
      if (!id) return "";
      let res = id;
      for (let i = 0; i < 6 - id.toString().length; i++) {
        res = "0" + res;
      }
      return res;
    },
    fluStatus (val, userType) {
      let str = "";
      if (userType == 1) {
        switch (val) {
          case 1:
            str = "法人人脸识别认证";
            break;
          case 2:
            str = "法人银行卡四要素";
            break;
          case 4:
            str = "企业授权书认证";
            break;
          case 5:
            str = "企业ap注册自动审核";
            break;
          case 7:
            str = "企业ap注册自动审核";
            break;
          default:
            str = "待审批";
            break;
        }
      } else {
        switch (val) {
          case 1:
            str = "人脸识别认证";
            break;
          case 2:
            str = "银行卡四要素";
            break;
          case 8:
            str = "运营商三要素";
            break;
          case 9:
            str = "非大陆居民手动认证";
            break;
          default:
            str = "其他";
            break;
        }
      }
      return str;
    }
  }
};
</script>

<style scoped lang="less">
.sdetails-dialog {
  .sdetails {
    height: 450px;
    overflow-x: hidden;
    margin: -20px -20px -10px;
    padding: 20px 20px 10px;

    .sdetails-item {
      padding: 20px 0;
      border-bottom: 1px solid #e7e7e7;

      .verification_ul {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .verification_li {
          color: #009899;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }

    b {
      color: #009899;
    }

    h5 {
      margin: 0;
      color: #009899;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 6px;
    }

    p {
      color: #333;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}
</style>




// WEBPACK FOOTER //
// components/processEvidence/index.vue